import React from 'react';
interface SegmentedApprovalToggleProps {
  options: [string, string];
  value: string;
  onChange: (value: string) => void;
}
export function SegmentedApprovalToggle({
  options,
  value,
  onChange
}: SegmentedApprovalToggleProps) {
  return <div className="bg-gray-100 p-1 rounded-full flex relative" data-id="element-237">
      {options.map(option => {
      const isSelected = value === option;
      return <button key={option} onClick={() => onChange(option)} className={`
              flex-1 py-2 px-4 text-sm font-medium rounded-full transition-all duration-200
              ${isSelected ? 'bg-violet-600 text-white shadow-sm' : 'text-gray-600 hover:text-gray-900'}
            `} data-id="element-238">
            {option}
          </button>;
    })}
    </div>;
}